import React from 'react';

import * as Styled from './styles';
import AccessList from '../AccessList';
import { TextIconsProps } from './types';

const TextIcons: React.FC<TextIconsProps> = ({ items }) => (
  <Styled.TextIcons>
    {items.map(({ key, title, subtitle, items: accessListItems }) => (
      <Styled.TextIconsCol {...{ key }}>
        <Styled.TextIconsTitle variant="headingM">{title}</Styled.TextIconsTitle>
        {subtitle && (
          <Styled.TextIconsSubtitle variant="textL">{subtitle}</Styled.TextIconsSubtitle>
        )}
        <Styled.TextIconsItems>
          <AccessList items={accessListItems} />
        </Styled.TextIconsItems>
      </Styled.TextIconsCol>
    ))}
  </Styled.TextIcons>
);

export default TextIcons;
